// extracted by mini-css-extract-plugin
export default {"root":"TagsSelector_root__F+eJX","loader":"TagsSelector_loader__F5WE1"};